import React from 'react';
import { ProdutosInteresseContent } from '../ProdutosInteresseContent';
import { ContentUpload } from '../ContentUpload/ContentUpload';
import { ModalUploadCoverageSetup } from '../ModalUploadCoverageSetup';
import Table from '../Table';
import { useSetupInfoAnaliseDeCoberturaStore } from '../../SetupInfoPanelAnaliseDeCobertura.store';
import { useUploadCoverageFiles } from '../../hooks/useUploadCoverageFiles';
import * as service from '../../services';
import styles from './InterestProducts.module.scss';

export const InterestProducts = () => {
  const {
    openModalProductUpload,
    productUploadResponse,
    productUploadError,
    isProductNewFile,
    produtoTableData,
    setCoberturaClickProsseguirProduto,
    setSetupInfoAnaliseDeCoberturaState,
    setCoberturaProdutoTableData,
    setCoberturaOpenModalProduto,
  } = useSetupInfoAnaliseDeCoberturaStore();

  const { uploadProgress, validateUploadProductFile } = useUploadCoverageFiles();

  const handleClickCloseModalUpload = () => {
    setCoberturaProdutoTableData();
    setSetupInfoAnaliseDeCoberturaState('openModalProductUpload', false);
  };

  const handleDownloadProductUploadErrors = async () => {
    await service.downloadProductUploadErrors(productUploadResponse?.uploadId);
    setSetupInfoAnaliseDeCoberturaState('openModalProductUpload', false);
  };

  const handleDownloadUploadedProducts = async () => {
    if (isProductNewFile) {
      await service.downloadDraftUploadedProducts(productUploadResponse);
    } else {
      await service.downloadCurrentUploadedProducts(productUploadResponse);
    }
  };

  const handlClickOpenModalUpload = () => {
    setCoberturaOpenModalProduto();
  };

  const handleClickProsseguir = () => {
    setCoberturaClickProsseguirProduto();
  };

  return (
    <div className={styles.container}>
      <ProdutosInteresseContent onClickDownloadModel={() => service.downloadCoberturaSetupTemplates('gtin')} />
      <ContentUpload
        error={productUploadError}
        tableData={[produtoTableData]}
        uploadBoxTitle="Enviar produtos via arquivo"
        uploadBoxSubtitle="Suba a sua lista de produtos selecionados para a análise através de um arquivo .csv"
        onClickOpenModalUpload={handlClickOpenModalUpload}
        table={<Table data={[produtoTableData]} isNewFile={isProductNewFile} onClickDownloadFile={handleDownloadUploadedProducts} />}
      />
      <ModalUploadCoverageSetup
        type="PRODUTO"
        show={openModalProductUpload}
        onClickDownloadModel={() => service.downloadCoberturaSetupTemplates('gtin')}
        invalidItems={productUploadResponse?.invalidos}
        uploadProgress={uploadProgress}
        onFileSelect={validateUploadProductFile}
        onHide={handleClickProsseguir}
        onClickCloseAndReset={handleClickCloseModalUpload}
        onClickDownloadErrors={handleDownloadProductUploadErrors}
      />
    </div>
  );
};
